"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDateToZonedTimeString = transformDateToZonedTimeString;
const date_fns_tz_1 = require("date-fns-tz");
const getAdjustedTimezone_1 = require("../helpers/getAdjustedTimezone");
function transformDateToZonedTimeString(date, timezone, format = "p") {
    const adjustedTimezone = (0, getAdjustedTimezone_1.getAdjustedTimezone)(timezone);
    return (0, date_fns_tz_1.formatInTimeZone)(date, adjustedTimezone, format);
}
//# sourceMappingURL=transformDateToZonedTimeString.js.map